/**
 * Utilidades para el tipo de contabilidad (blanco = A / negro = B) de cajas y comprobantes.
 *
 * `CashBox.accountingType` se guarda como string: hoy 'A' | 'B' | 'AMBAS', pero hay
 * datos antiguos con labels ('Contabilidad A', etc.). `normalizeAccountingType` los unifica.
 */

/** Normaliza el tipo de contabilidad de una caja a 'A' | 'B' | 'AMBAS' (o el valor crudo si no matchea). */
export const normalizeAccountingType = (
  type: string | undefined | null,
): string | undefined => {
  if (!type) return undefined;
  const map: Record<string, string> = {
    'Contabilidad General': 'A',
    'Contabilidad A': 'A',
    'Contabilidad B': 'B',
    'Ambas Contabilidades': 'AMBAS',
  };
  return map[type] ?? type;
};

/**
 * ¿Una caja con este tipo de contabilidad puede usarse para un pago del tipo `target`?
 * - `target` nulo/indefinido (comprobante sin tipo de contabilidad) → se permite cualquier caja.
 * - Caja sin tipo definido → se permite (tolerancia con datos previos a este campo).
 * - Caja 'AMBAS' → se permite siempre.
 * - Si no, el tipo de la caja debe coincidir con `target`.
 */
export const cashBoxMatchesAccountingType = (
  cashBoxAccountingType: string | undefined | null,
  target: string | undefined | null,
): boolean => {
  if (!target) return true;
  const cb = normalizeAccountingType(cashBoxAccountingType);
  return !cb || cb === 'AMBAS' || cb === target;
};
